<template>
  <div :class="_class">
    <!-- @slot Breadcrumb 内容 -->
    <slot />
  </div>
</template>

<script>
import Icon from '../icon';

const name = 'ten-breadcrumb';

export default {
  name,
  provide() {
    return {
      breadcrumb: this,
    };
  },
  props: {
    /**
     * 自定义分隔符
     */
    separator: {
      type: String,
      default: '',
    },
  },
  computed: {
    _class() {
      return [
        name,
        {
          [`${name}-border`]: this.border,
        },
      ];
    },
  },
  methods: {
    renderSeparator() {
      if (this.$scopedSlots.separator) {
        return this.$scopedSlots.separator();
      } if (this.separator) {
        return this.separator;
      }
      return <Icon icon="right" />;
    },
  },
};
</script>
